import React from 'react'
import Auto from '../../Images/New/ListItem/repair.png'
import Unit from '../../Images/New/ListItem/unit.png'
import Cart from '../../Images/New/ListItem/cart.png'
import Chemical from '../../Images/New/ListItem/chemical.png'
import Computer from '../../Images/New/ListItem/computer.png'
import Electric from '../../Images/New/ListItem/electric.png'
import Furniture from '../../Images/New/ListItem/furniture.png'
import Mobile from '../../Images/New/ListItem/mobile.png'
import Paint from '../../Images/New/ListItem/paint.png'
import Pharma from '../../Images/New/ListItem/pharma.png'
import Plane from '../../Images/New/ListItem/plane.png'
import Resturant from '../../Images/New/ListItem/resturant.png'
import Retail from '../../Images/New/ListItem/retail.png'
import Stationary from '../../Images/New/ListItem/stationary.png'
import Tshirt from '../../Images/New/ListItem/tshirt.png'
import Hardware from '../../Images/New/ListItem/drill.png'
import Factory from '../../Images/New/ListItem/factory.png'
import Work from '../../Images/New/ListItem/work.png'

const ListItems = () => {
  return (
    <>
      <div className="flex flex-col items-center justify-center pb-10">
        <div className="text-center text-5xl font-semibold py-20">
          Accounting Software For Your Industry
        </div>
        <div className="max-w-7xl grid grid-cols-2 sm:grid-cols-6 w-full gap-y-10 sm:gap-y-20">
          <div className="flex flex-col justify-end items-center">
            <img src={Factory} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Textile</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Unit} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">
              Engineering Unit
            </p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Retail} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Retail</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Tshirt} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Garments</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Work} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Job Work</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Computer} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Agency</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Plane} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Travel</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Cart} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">FMCG</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Electric} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Electrical</p>
          </div>

          <div className="flex flex-col justify-end items-center">
            <img src={Stationary} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Stationary</p>
          </div>

          <div className="flex flex-col justify-end items-center">
            <img src={Mobile} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Mobile Store</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Resturant} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">
              Food & Beverage
            </p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Pharma} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Pharma</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Furniture} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Furniture</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Chemical} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Chemical</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Paint} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Paint</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Auto} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Auto Parts</p>
          </div>
          <div className="flex flex-col justify-end items-center">
            <img src={Hardware} className="w-[20%]" alt="Card" />
            <p className="sm:text-2xl text-lg  font-semibold">Hardware</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ListItems;